import { useState } from "react";
import { Sparkles } from "lucide-react";
import api from "@/lib/api";
import { toast } from "sonner";

const EVENTS = ["Birthday","Fiesta","Church Gathering","Graduation","Office Lunch","Family Party","Holiday Celebration"];
const TRAYS = [
  { id: "pancit-s", name: "Pancit Canton Tray (Small)", serves: "8-12", price: 49.95 },
  { id: "pancit-m", name: "Pancit Canton Tray (Medium)", serves: "15-20", price: 79.95 },
  { id: "pancit-l", name: "Pancit Canton Tray (Large)", serves: "40-45", price: 149.95 },
  { id: "lumpia", name: "Lumpia Tray (50 pcs)", serves: "10-15", price: 39.95 },
  { id: "bbq", name: "Pork BBQ Tray (30 sticks)", serves: "15-20", price: 89.95 },
];

export default function Catering() {
  const [form, setForm] = useState({ customer_name: "", customer_email: "", customer_phone: "", event_type: "Birthday", guests: 20, event_date: "", event_time: "", notes: "" });
  const [selected, setSelected] = useState({});
  const submit = async (e) => {
    e.preventDefault();
    try {
      const trays = Object.entries(selected).filter(([_, q]) => q > 0).map(([id, qty]) => ({ id, qty, ...TRAYS.find(t => t.id === id) }));
      await api.post("/catering", { ...form, selected_trays: trays });
      toast.success("Catering request submitted!");
      setForm({ ...form, notes: "" });
      setSelected({});
    } catch (e) { toast.error("Submission failed"); }
  };
  return (
    <div className="min-h-screen bg-[#FAF9F6]" data-testid="catering-page">
      <section className="bg-[#2C4A3B] text-[#FAF9F6] py-14">
        <div className="max-w-6xl mx-auto px-4 lg:px-8">
          <Sparkles className="w-10 h-10 text-[#D4AF37] mb-2"/>
          <h1 className="font-heading text-5xl mb-2">Catering & Party Trays</h1>
          <p className="text-[#FAF9F6]/80 max-w-xl">From small family parties to big fiestas — we cater Filipino feasts with love. Tell us about your event.</p>
        </div>
      </section>
      <form onSubmit={submit} className="max-w-6xl mx-auto px-4 lg:px-8 py-12 grid lg:grid-cols-2 gap-10">
        <div>
          <h2 className="font-heading text-2xl text-[#1A2421] mb-4">Choose your trays</h2>
          <div className="space-y-3">
            {TRAYS.map((t) => (
              <div key={t.id} className="mart-card p-4 flex items-center gap-4" data-testid={`tray-${t.id}`}>
                <div className="flex-1">
                  <div className="font-heading text-lg text-[#1A2421]">{t.name}</div>
                  <div className="text-xs text-[#5C6B64]">Serves {t.serves}</div>
                </div>
                <div className="font-heading text-[#2C4A3B] font-semibold">${t.price}</div>
                <input
                  type="number" min="0" max="20"
                  data-testid={`tray-qty-${t.id}`}
                  value={selected[t.id] || 0}
                  onChange={(e) => setSelected({...selected, [t.id]: parseInt(e.target.value || "0")})}
                  className="w-16 border border-[#8A9A86]/40 rounded px-2 py-1 text-center"
                />
              </div>
            ))}
          </div>
        </div>
        <div>
          <h2 className="font-heading text-2xl text-[#1A2421] mb-4">Event details</h2>
          <div className="space-y-3">
            <input required placeholder="Your full name" data-testid="catering-name" className="w-full border border-[#8A9A86]/40 rounded px-4 py-3 bg-white" value={form.customer_name} onChange={(e) => setForm({...form, customer_name: e.target.value})}/>
            <div className="grid grid-cols-2 gap-3">
              <input required placeholder="Phone" data-testid="catering-phone" className="border border-[#8A9A86]/40 rounded px-4 py-3 bg-white" value={form.customer_phone} onChange={(e) => setForm({...form, customer_phone: e.target.value})}/>
              <input type="email" placeholder="Email" data-testid="catering-email" className="border border-[#8A9A86]/40 rounded px-4 py-3 bg-white" value={form.customer_email} onChange={(e) => setForm({...form, customer_email: e.target.value})}/>
            </div>
            <div className="grid grid-cols-2 gap-3">
              <select data-testid="catering-event" value={form.event_type} onChange={(e) => setForm({...form, event_type: e.target.value})} className="border border-[#8A9A86]/40 rounded px-4 py-3 bg-white">
                {EVENTS.map(e => <option key={e}>{e}</option>)}
              </select>
              <input type="number" placeholder="Guests" data-testid="catering-guests" className="border border-[#8A9A86]/40 rounded px-4 py-3 bg-white" value={form.guests} onChange={(e) => setForm({...form, guests: parseInt(e.target.value || "1")})}/>
            </div>
            <div className="grid grid-cols-2 gap-3">
              <input required type="date" data-testid="catering-date" className="border border-[#8A9A86]/40 rounded px-4 py-3 bg-white" value={form.event_date} onChange={(e) => setForm({...form, event_date: e.target.value})}/>
              <input type="time" data-testid="catering-time" className="border border-[#8A9A86]/40 rounded px-4 py-3 bg-white" value={form.event_time} onChange={(e) => setForm({...form, event_time: e.target.value})}/>
            </div>
            <textarea data-testid="catering-notes" rows={4} placeholder="Special requests or notes..." className="w-full border border-[#8A9A86]/40 rounded px-4 py-3 bg-white" value={form.notes} onChange={(e) => setForm({...form, notes: e.target.value})}/>
            <button type="submit" data-testid="catering-submit" className="btn-mart w-full py-4">Submit Inquiry</button>
          </div>
        </div>
      </form>
    </div>
  );
}
